import { render, staticRenderFns } from "./DialogUpdateClient.vue?vue&type=template&id=079990e8&"
import script from "./DialogUpdateClient.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079990e8')) {
      api.createRecord('079990e8', component.options)
    } else {
      api.reload('079990e8', component.options)
    }
    module.hot.accept("./DialogUpdateClient.vue?vue&type=template&id=079990e8&", function () {
      api.rerender('079990e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogUpdateClient.vue"
export default component.exports